import { getFirestore, collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import { app } from "../config";

const db = getFirestore(app);

// Helper to convert Firestore Timestamp or date string to Date object
const parseDate = (value) => {
  if (!value) return null;
  if (value.toDate && typeof value.toDate === 'function') {
    return value.toDate();
  }
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
};

// Define the function to get all event details for the current user
const getMPSEventAppliedStatus = async (userId) => {
  try {
    // Reference the mpsEventRegistration collection and create a query
    const eventRegistrationRef = collection(db, "mpsEventRegistration");
    const userQuery = query(eventRegistrationRef, where("userId", "==", userId));

    // Execute the query and get the documents
    const querySnapshot = await getDocs(userQuery);

    // Extract event details from the matching documents
    const registrations = querySnapshot.docs.map((docSnap) => {
      const data = docSnap.data();
      return {
        applicationId: docSnap.id,
        eventId: data.eventId,
        applicationStatus: data.applicationStatus,
        paymentStatus: data.paymentStatus,
        denialReason: data.denialReason || null,
      };
    });

    // Fetch full event data for each registration
    const eventDetails = await Promise.all(
      registrations.map(async (reg) => {
        try {
          const eventDocRef = doc(db, "events", reg.eventId);
          const eventDoc = await getDoc(eventDocRef);
          if (eventDoc.exists()) {
            const eventData = eventDoc.data();
            const startDate = parseDate(eventData.startDate);
            const endDate = parseDate(eventData.endDate);
            return {
              ...reg,
              eventName: eventData.eventName,
              eventCoverPhoto: eventData.eventCoverPhoto,
              startDate: startDate ? startDate.toISOString() : null,
              endDate: endDate ? endDate.toISOString() : null,
              date: startDate ? startDate.toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric"
              }) : null,
              location: eventData.location || '',
              sellerTypes: eventData.sellerTypes || [],
            };
          }
          return reg;
        } catch (err) {
          console.warn(`Error fetching event ${reg.eventId}:`, err);
          return reg;
        }
      })
    );

    return { success: true, eventDetails };
  } catch (error) {
    console.error("Error fetching event details:", error);
    return { success: false, message: `Error fetching event details: ${error.message}` };
  }
};

// Define the function to get all event details for the current user
const getMPSEventAppliedStatusById = async (userId, eventId) => {
  try {
    // Reference the mpsEventRegistration collection and create a query with both conditions
    const eventRegistrationRef = collection(db, "mpsEventRegistration");

    // Create a query with both `userId` and `eventId` conditions
    const userEventQuery = query(
      eventRegistrationRef,
      where("userId", "==", userId),
      where("eventId", "==", eventId)
    );

    // Execute the query and get the documents
    const querySnapshot = await getDocs(userEventQuery);
    // Extract event details from the matching documents
    const eventDetails = querySnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        applicationId: doc.id,
        eventId: data?.eventId,
        applicationStatus: data?.applicationStatus || null,
        paymentStatus: data?.paymentStatus || null,
        assignedBooth: data?.assignedBooth || null,
      };
    });

    return { success: true, eventDetails };
  } catch (error) {
    console.error("Error fetching Event Applied status for user and event:", error);
    return { success: false, message: `Error fetching Event Applied status for user and event: ${error.message}` };
  }
};


export { getMPSEventAppliedStatus, getMPSEventAppliedStatusById };
